module.exports = __webpack_public_path__ + "img/dark-drop.4f6c4e3b.png";